export const normalizeCurrency = (
    value: string | number | null | undefined,
    fallback = "0,00"
): string => {
    if (value === null || value === undefined) {
        return fallback;
    }

    let str: string;

    if (typeof value === "number") {
        str = value.toFixed(2).replace(".", ",");
    } else if (typeof value === "string") {
        str = value.replace(/[^0-9.,]/g, "").replace(/\.(?=\d{3})/g, "").replace(",", ".");
        const num = parseFloat(str);
        if (isNaN(num)) {
            return fallback;
        }
        str = num.toFixed(2).replace(".", ",");
    } else {
        return fallback;
    }

    const [integerPart, decimalPart] = str.split(",");

    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    const formattedDecimal = (decimalPart || "").padEnd(2, "0").slice(0, 2);

    return `${formattedInteger},${formattedDecimal}`;
};